import { RefinementItem } from "../types";

export function filterCertificateWithoutSubValue(
  items: RefinementItem[],
  filterCategory: string,
): RefinementItem[] {
  return items.filter((item: RefinementItem) => {
    if (
      (filterCategory === "program_type" || filterCategory === "productType") &&
      item.value.toLowerCase() === "certificate"
    ) {
      if (item.count === 1) {
        return false;
      }
    }
    return true;
  });
}
